import { AbstractControl, ValidatorFn } from '@angular/forms'

export function emailWithTldValidator(): ValidatorFn {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/ // require top-level domain

  return (control: AbstractControl) => {
    const value = control.value as string
    if (!value) return null

    return regex.test(value) ? null : { email: true }
  }
}
